import { Alert, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatInstant } from '@/i18n/format';
import { useLocale } from '@/i18n/useLocale';
import { useMe } from './meHooks';

function formatUntil(iso: string, locale: string, timeZone: string): string {
  try {
    return formatInstant(iso, locale, timeZone);
  } catch {
    return iso;
  }
}

export function DeletionPendingAlert({
  until,
  settingsLink = false,
}: {
  until: string;
  settingsLink?: boolean;
}) {
  const { t } = useTranslation();
  const locale = useLocale();
  const me = useMe();
  const untilText = formatUntil(until, locale, me.user.timezone ?? 'UTC');
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      {t('locked.deletionPending', { until: untilText })}
      {settingsLink && (
        <Link component={RouterLink} to="/me/settings" sx={{ ms: 1 }}>
          {t('nav.settings')}
        </Link>
      )}
    </Alert>
  );
}
